//
// GENERATED by KVision
//
package pl.finn.forms.tw17

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class Tw17Service : ITw17Service

object Tw17ServiceManager : KVServiceManager<Tw17Service>(Tw17Service::class) {
    init {
        registerKVisionServiceExceptions()
        bind(ITw17Service::nowy, HttpMethod.POST, null)
        bind(ITw17Service::edycja, HttpMethod.POST, null)
        bind(ITw17Service::sprawdz, HttpMethod.POST, null)
        bind(ITw17Service::zapisz, HttpMethod.POST, null)
        bind(ITw17Service::podglad, HttpMethod.POST, null)
    }
}
